import { useFormikContext, ErrorMessage } from 'formik'
import React from 'react'
import { cn } from '../../lib/utils'
import { Label } from '../../ui/label'
import { Input } from '../../ui/input'
import BackgroundGradientDemo from '../../components/card.v2'
import { HoverBorderGradientDemo } from '../../components/Button'
import { GabbiLogo } from '../../components/Gabbi.logo'

export const LabelInputContainer = ({ children, className }) => {
  return (
    <div className={cn('flex flex-col space-y-2 w-full', className)}>
      {children}
    </div>
  )
}

const Signup = ({ currentStep, setCurrentStep }) => {
  const { handleBlur, errors, values, setFieldValue } = useFormikContext()

  const handleInputChange = (e) => {
    const { name, value } = e.target
    // setFieldValue(`userData.${name}`, value) // Update userData dynamically
    setFieldValue(name, value)
  }
  console.log('ERRORS', errors)

  return (
    <div className='flex flex-col md:flex-row min-h-screen relative'>
      {/* Left Section */}
      <div className='flex-col justify-center items-center text-white px-6 py-10 md:w-1/2 bg-[#065AD8] relative hidden md:flex'>
        <div className='absolute top-[48px] left-[48px]'>
          <GabbiLogo />
        </div>
        <div className='max-w-sm md:max-w-sm 2xl:max-w-2xl overflow-hidden'>
          <div className='flex gap-12'>
            <video src='/videos/slide.webm' autoPlay loop muted playsInline />
          </div>
        </div>

        <div className='absolute z-10 bottom-4'>
          <h2 className='text-7xl text-center font-semibold mb-3'>Sign Up</h2>
          <p className='text-3xl text-center'>
            Connect with every application.
          </p>
          <p className='text-lg text-center m-0'>
            Everything you need is in an easily customizable dashboard
          </p>
        </div>
      </div>

      {/* Right Section */}

      <div className='flex justify-center items-center md:w-1/2 bg-white relative overflow-hidden w-full px-4'>
        <div className='absolute rounded-3xl top-0 right-0 transform translate-x-2/3 -translate-y-3/1 hidden md:block'>
          <div className='w-52 h-52 bg-gradient-to-r from-[#65B5FB] via-[#65B5FB] to-[#2479FA] transform rotate-45 rounded-xl'></div>
        </div>
        <div className='absolute bottom-0 right-0 transform translate-x-1/2 translate-y-1/2 hidden md:block'>
          <div className='w-32 h-32 bg-gradient-to-r from-[#23CAFB] via-[#2479FA] to-[#2479FA] transform rotate-45'></div>
        </div>
        <div className=' mt-16 md:mt-0'>
          <BackgroundGradientDemo className={'max-w-sm min-w-80'}>
            {/* Form Card */}
            {/* Heading */}
            <h2 className='text-2xl font-bold text-[#2446f9]  bg-clip-text mb-2'>
              Sign Up Account
            </h2>
            <p className='text-[#2446f9] text-sm bg-clip-text mb-6'>
              Enter your personal data to create your account
            </p>

            {/* Social Buttons */}
            {/* <div className='flex flex-col sm:flex-row justify-between mb-6 space-y-4 sm:space-y-0 sm:space-x-4'>
            <button
              disabled={true}
              className='flex items-center justify-center w-full sm:w-1/2  rounded-lg py-3 bg-gray-300 hover:bg-gray-300'
            >
              <img
                src='https://img.icons8.com/color/48/google-logo.png'
                alt='Google'
                className='w-6 h-6 mr-2'
              />
              Google
            </button>
            <button
              disabled={true}
              className='flex items-center justify-center w-full sm:w-1/2  rounded-lg py-3 bg-gray-300 hover:bg-gray-300'
            >
              <img
                src='https://cdn-icons-png.flaticon.com/512/0/747.png'
                alt='Apple'
                className='w-6 h-6 mr-2'
              />
              Apple
            </button>
          </div> */}
            <form>
              {/* First Name & Last Name */}
              <div className='flex flex-col sm:flex-row gap-2 mt-4'>
                <div className='flex-1'>
                  <LabelInputContainer>
                    <Label htmlFor='firstname'>First name</Label>
                    <Input
                      id='firstname'
                      type='text'
                      name='userData.firstName'
                      value={values?.userData?.firstName || ''}
                      onChange={handleInputChange}
                      placeholder='First Name'
                      onBlur={handleBlur}
                    />
                    <ErrorMessage
                      name={'userData.firstName'}
                      component={'div'}
                      className='text-xs text-red-500 font-light mt-1'
                    />
                  </LabelInputContainer>
                </div>
                <div className='flex-1'>
                  <LabelInputContainer>
                    <Label htmlFor='lastName'>Last name</Label>
                    <Input
                      id='lastName'
                      type='text'
                      name='userData.lastName'
                      value={values?.userData?.lastName || ''}
                      onChange={handleInputChange}
                      placeholder='Last Name'
                      onBlur={handleBlur}
                    />
                    <ErrorMessage
                      name={'userData.lastName'}
                      component={'div'}
                      className='text-xs text-red-500 font-light mt-1'
                    />
                  </LabelInputContainer>
                </div>
              </div>

              {/* Email */}
              <div className='mt-4'>
                <LabelInputContainer>
                  <Label htmlFor='email'>Email</Label>
                  <Input
                    id='email'
                    type='email'
                    name='userData.email'
                    value={values?.userData?.email || ''}
                    onChange={handleInputChange}
                    placeholder='Email'
                    onBlur={handleBlur}
                  />
                  <ErrorMessage
                    name={'userData.email'}
                    component={'div'}
                    className='text-xs text-red-500 font-light mt-1'
                  />
                </LabelInputContainer>
              </div>

              {/* Telephone */}
              <div className='mt-4'>
                <LabelInputContainer>
                  <Label htmlFor='telephone'>Telephone Number</Label>
                  <Input
                    id='telephone'
                    type='tel'
                    name='userData.telephone'
                    value={values?.userData?.telephone || ''}
                    onChange={handleInputChange}
                    placeholder='Telephone Number'
                    onBlur={handleBlur}
                  />
                  <ErrorMessage
                    name={'userData.telephone'}
                    component={'div'}
                    className='text-xs text-red-500 font-light mt-1'
                  />
                </LabelInputContainer>
              </div>
              {console.log('CHECK', !!errors?.userData)}

              {/* Submit Button */}
              <div className='mt-8'>
                <HoverBorderGradientDemo
                  type='button'
                  disable={!!errors?.userData}
                  onClick={() => {
                    !errors?.userData && setCurrentStep(currentStep + 1)
                  }}
                >
                  <span className='font-bold capitalize'>
                    Start your journey
                  </span>
                </HoverBorderGradientDemo>
              </div>
            </form>

            <p className='text-center text-gray-900 text-md mt-4'>
              Already have an account?{' '}
              <a href='#' className='font-bold text-[#2446f9]'>
                Log in
              </a>
            </p>
          </BackgroundGradientDemo>
        </div>
      </div>
    </div>
  )
}

export default Signup
